import { request } from '@/shared/api/request'

export const getEmployerActivityByIINAndBin = (params) => {
	return request({ url: 'contract/universalMethods/requestUlFlData', method: 'GET', params })
}
